// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App' // 页面主入口
import router from './router' // 路由
import axios from 'axios' // 数据请求
import VueAwesomeSwiper from 'vue-awesome-swiper' // 轮播图
import $ from 'jquery'
import moment from 'moment'; // 时间插件
import jqueryMousewheel from 'jquery-mousewheel';
import util from '../static/js/util'

// axios.defaults.withCredentials=true;
// 设置为 false 以阻止 vue 在启动时生成生产提示;
Vue.config.productionTip = false

//切换路由时改变列表页title
Vue.use(require('vue-wechat-title'));

// Vue.prototype.HOST = '/member/api';
// 创建基本的axios配置
// var $http = axios.create({
//   baseURL:'http://college.breadoffer.com'
// })
// Vue.prototype.$http =  $http;

Vue.prototype.$http =  axios;
// 设置全局图片基本url
// Vue.prototype.resourceUrl = 'http://resource.breadoffer.com';
Vue.prototype.resourceUrl = util.Domain.getImg();
// Vue.prototype.resourceUrl =  window.resourceUrl;

// 通过url获取参数的函数
Vue.prototype.GetQueryString = function (name){
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

//将空格转为换行的函数
Vue.prototype.formatSolution = function (text){
   if (text) {
　　　return text.replace(/\n/g,'<br/>')
　 } else return ''
}
// 关于时间的过滤器
Vue.filter('moment' , function(date) {
   moment.locale('zh-cn')//设置为中文(列表页)
   return moment(date).fromNow();
});

Vue.filter('Moment' , function(date) {
  moment.locale('en');//设置为英文(banner部分)
  return moment(date,'YYYYMMDD').format('MMMM Do, YYYY')
});

Vue.filter('Month' , function(date) {
  moment.locale('en');//设置为英文
   return moment(date).format('MMM')//右侧活动转化为月份
});


// 导入公共部分
import '../static/css/reset.css' // 重置样式
import '../static/css/plugin-common.css' // 修改插件样式的css
import '../static/css/reply.css' // 评论回复样式
import '../static/css/animate.css' // 动画css
import 'iview/dist/styles/iview.css'; // iview组件css
require(['../static/js/jquery.mousewheel.js']);
require (['../static/js/jquery.mCustomScrollbar.min.js']);
require (['../static/js/jquery.mCustomScrollbar.concat.min.js']);
require (['../static/js/jquery-ui.min.js']);


Vue.use(VueAwesomeSwiper);
Vue.use(jqueryMousewheel);

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  updated(){
    if(window.location.href.indexOf('404' || 'empty') == -1){
      $('.content').mCustomScrollbar("destroy"); // 在页面刷新前将滚动条样式清除，恢复到默认样式
    }
  }
})

// 切换路由时需执行的操作
vm.$watch('$route',function(){
	// 调用滚动动条函数
  if(window.location.href.indexOf('404' || 'empty') == -1){
    $('.content').mCustomScrollbar();
  }


	//首页轮播图函数
	var btn = $('#shouye-btn1,#shouye-btn2');
	btn.on('click',function(){
		getbanner('.swiper-slide-active');
	});
	// 将轮播图放入左侧div中
	function getbanner(className){
		var item = $('.img-wrap').find(className).prev();
		var src = item.find('img').attr('src');
		var href = item.find('a').attr('href');
		var label = item.find('a').find('.ban-text').find('h4').text();
		var title = item.find('a').find('.title').text();
		var desc = item.find('a').find('.desc').text();
		$('.banner-left').addClass('fadeIn');
		setTimeout(function(){
			$('.banner-left').removeClass('fadeIn');
		}, 1000);
		$('.banner-left').find('img').attr('src',src);
		$('.banner-left').find('a').attr('href',href);
		$('.banner-left').find('a').find('.ban-text').find('h3').text(label);
		$('.banner-left').find('a').find('.ban-text').find('.title').text(title);
		$('.banner-left').find('a').find('.ban-text').find('.desc').text(desc);
	}

	// 列表页下拉菜单悬停效果
	$(".industry-select,.city-select,.type-select").on("mouseover", ".wanna-hover", function () {
			$(this).find('.hover-span').stop(true, true).animate({width: '20px', marginRight: '6px'}, 'normal');
	});
  $(".industry-select,.city-select,.type-select").on("mouseout", ".wanna-hover", function () {
			$(this).find('.hover-span').stop(true, true).animate({width: '0', marginRight: '0'}, 'normal');
	});
})



// WEBPACK FOOTER //
// ./src/main.js